module.exports = __webpack_public_path__ + "img/research3.5d65e999.jpg";